import moment from 'moment'
import { ServiceTime, ServiceTimeKindType } from '@ancon/wildcat-types'
import { Translate } from 'next-translate'

/**
 * How the refused pickup time reads in the modal copy. An ASAP order carries an
 * empty time, so it is named rather than formatted.
 */
export default function getCapacityConflictRequestedTimeLabel(
  serviceTime: ServiceTime | null,
  t: Translate,
): string {
  if (
    !serviceTime?.time ||
    serviceTime.kind === ServiceTimeKindType.AsSoonAsPossible
  ) {
    return t('checkoutCapacityConflict.asSoonAsPossible')
  }

  return moment(serviceTime.time).format('LT')
}
